import { usingGet } from '@ocean/api'

export const getPproDetails = (pproId: Guid, resultId?: Guid) => {
  const baseUrl = `PersonalEvaluations/details/${pproId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}
